// import { topSlider } from "../modules/top-slider.js";

// export 文を使って関数 greet1 を定義
export const loadingAni = () => {
  $(window).bind("load", function () {
    setTimeout(() => {
      $("html").removeClass("is_loadding");
      $("body").addClass("is-MV-show");
    }, 800);
  });
};
